import { useState, useEffect } from 'react';
import useCustomNavigate from '../../../hooks/useCustomNavigate';
import { Modal, Divider, Form, Input, Button, message, Select } from 'antd';
import axios from "./../../../services/http";

const ModalFormUsuario = ({ action, userData, openDialogUser, cancelDialogUser, reloadData }) => {

    const navigate = useCustomNavigate();
    const [userForm] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [profiles, setProfiles] = useState([]);

    useEffect(() => {
        GetProfiles();
    }, []);

    useEffect(() => {
        if (userData) GetUserById();
    }, [userData]);

    const GetProfiles = async () => {
        try {
          const response = await axios.HTTP_POST("/api/v1/profiles/list", {});
          setProfiles(response.data);
        } catch (e) {
          console.error('Error al obtener los perfiles:', e);
          message.error('Error al obtener los perfiles');
        }
    }

    const GetUserById = async () => {
        try {
            const response = await axios.HTTP_GET(`/api/usuarios/${userData}`);
            userForm.setFieldsValue({ usuario: response.usuario, rol_id: response.rol_id });

        } catch (error) {
            console.error('Error al cargar el usuario:', error);
            message.error('Error al cargar el usuario: ', error);
        } finally {
            setLoading(false);
        }
    }

    const handlePending = async (values) => {
        try {
            setLoading(true);
            if (action === "update") values["id"] = userData
            const hide = message.loading('Guardando usuario, espere un momento..', 0);
            let url = action === "create" ? "/api/usuarios" : `/api/usuarios/${userData}`;
            let response = (action === "create") ? await axios.HTTP_POST(url, values) : await axios.HTTP_PUT(url, values);

            if (response) {
                hide();
                message.success(response.data.message);
                cancelDialogUser(false);
                userForm.resetFields();
                reloadData();
            }

        } catch (error) {
            console.error('Error al guardar el usuario:', error);
            message.error('Error al guardar el usuario: ', error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <Modal
                title={`${action === "create" ? "Nuevo" : "Editar"} usuario`}
                open={openDialogUser}
                onCancel={() => cancelDialogUser(false)}
                footer={null}
                >
                <Divider style={{ margin: '24px 0' }} />
                <Form
                    layout="vertical"
                    form={userForm}
                    onFinish={handlePending}
                >
                    <Form.Item
                        label="Usuario"
                        name="usuario"
                        autoComplete="off"
                        rules={[{ required: true, message: 'Por favor ingresar el usuario' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="contrasena"
                        label="Contraseña"
                        rules={
                            action === "update" ? [] : [{ required: true, message: 'Por favor ingresa una contraseña' }]
                        }
                        >
                        <Input.Password />
                    </Form.Item>
                    <Form.Item
                        name="rol_id"
                        label="Perfil"
                        rules={[{ required: true, message: 'Por favor selecciona los privilegios' }]}
                        >
                        <Select placeholder="Selecciona un perfil" style={{ width: "100%" }}>
                            {profiles.map((item) => (
                            <Select.Option key={item.id} value={item.id}>
                                {item.name}
                            </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Divider style={{ margin: '24px 0' }} />
                    <Form.Item>
                        <div className='w-full flex flex-end gap-10'>
                            <Button type="default" onClick={() => { userForm.resetFields(); cancelDialogUser(false); }}>
                                Cancelar
                            </Button>
                            <Button type="primary" loading={loading} htmlType="submit">
                                Guardar
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ModalFormUsuario;